/** @module Pages/Reports/Utils */

export const MONTHS = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

/** Encabezados de "Día semana" en la matriz del Power BI (semana desde el lunes). */
export const WEEK_DAYS = ["lu.", "ma.", "mi.", "ju.", "vi.", "sá.", "do."];

export const PAGE_SIZE = 500;

/**
 * Convierte "YYYY-MM-DD" a "DD-MM-YYYY" sin pasar por Date (evita corrimientos por zona horaria).
 * @param {string} value
 * @returns {string}
 */
export const format_date = (value) => {
    if (!value) return "";
    const [y, m, d] = value.slice(0, 10).split("-");
    return `${d}-${m}-${y}`;
};

/**
 * Formatea el valor de una celda según el tipo de columna que informa el backend.
 * @param {*} value
 * @param {string} type - string | date | time
 */
export const format_cell = (value, type) => {
    if (value === null || value === undefined) return "";
    return type === "date" ? format_date(value) : value;
};

/**
 * Filtros de la API a partir de los segmentadores (selección única; vacío = todos).
 * @param {object} slicers - {year, month, nombre, centro}
 */
export const build_filters = ({year, month, nombre, centro}) => ({
    years: year ? [year] : [],
    months: month ? [month] : [],
    nombres: nombre ? [nombre] : [],
    centros_costo: centro ? [centro] : [],
});

/**
 * Texto de la celda del calendario, igual a la medida DAX "Eventos": número del día, línea en
 * blanco y por cada visita el centro de costo y las horas.
 * @param {object} day - {day, events}
 * @param {boolean} with_persona - Mostrar el nombre (cuando el mes tiene varias personas)
 */
export const events_text = (day, with_persona) => {
    const events = day.events.map((e) => {
        const lines = [];
        if (with_persona) lines.push(e.persona);
        lines.push(e.centro_costo || "");
        lines.push(` Ingreso: ${e.hora_entrada || ""} Salida: ${e.hora_salida || ""}`);
        return lines.join("\n");
    });
    return [String(day.day), ...events].join("\n\n");
};

export const today = () => {
    const now = new Date();
    return {year: now.getFullYear(), month: now.getMonth() + 1};
};
